import type { Establishment } from "@/types/http/Establishment"
import { getCountry } from "@/router/utils/getCountry"
import type { Establishment as HistoricOrderEstablishment } from "@/http/models/HistoricOrder"

export function establishmentPageRouteParams(establishment: Establishment | HistoricOrderEstablishment) {
  const country = establishment.location.city.country.code.toLowerCase()

  const params = {
    city: establishment.location.city.slug,
    slug: establishment.slug,
  }

  if (country !== getCountry().value) {
    params.country = country
  }

  return params
}